import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Store} from '@ngrx/store';

import {AppState} from '../../../../../core/store/core.state';
import {FeaturesMapService} from "../../../../map/services";
import {Chacra} from "../../../../../chacra-core/models/chacra";

export interface ChacrasMapDetailData {
  chacraId: string;
}

@Component({
  selector: 'app-chacras-map-detail',
  templateUrl: './chacras-map-detail.component.html',
  styleUrls: ['./chacras-map-detail.component.scss']
})
export class ChacrasMapDetailComponent {
  @Output() onClose = new EventEmitter();
  @Input() dataInput: ChacrasMapDetailData = null;

  title = 'Datos de chacra';
  submitText = 'Dibujar';
  cancelText = 'Cancelar';

  formValue: Chacra;

  constructor(
    private store: Store<AppState>,
    protected mapService: FeaturesMapService,
  ) {}

  onCancel() {
    this.onClose.emit();
  }

  onSubmit() {
    this.mapService.launchSketchAction('create');
    this.onClose.emit();
  }
}
